import { List, Typography, makeStyles, Theme } from "@material-ui/core";
import { Title, useAuthenticated } from "react-admin";
import { useHistory } from "react-router-dom";
import { ExportImportItem } from "./ExportImportItem";
import { dataTransferCategories } from "./dataTransferConfig";
import { useActionPermissions } from "../../../common/auth/useActionPermissions";
import permissionNames from "../../../common/auth/access-control/permissionNames";

const useStyles = makeStyles((theme: Theme) => ({
  page: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
  },
}));

const DataImportExport = () => {
  useAuthenticated();
  const classes = useStyles();
  const history = useHistory();
  const permissions = useActionPermissions();

  const categories = dataTransferCategories.filter((category) => {
    if (!permissions) {
      return false;
    }

    switch (category.key) {
      case "drivers":
        return Boolean(
          permissions[permissionNames.admin.driverExport.main] ||
            permissions[permissionNames.admin.driverImport.main] ||
            permissions[permissionNames.admin.drivers.main]
        );
      case "vehicles":
        return Boolean(permissions[permissionNames.admin.vehicles.main]);
      case "trailers":
        return Boolean(permissions[permissionNames.admin.trailers.main]);
      case "locations":
        return Boolean(permissions[permissionNames.locations.history.main]);
      default:
        return false;
    }
  });

  return (
    <div className={`content-container ${classes.page}`}>
      <Title title="Data Import / Export" />
      <div>
        <Typography variant="h5" gutterBottom>
          Data Import / Export
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Choose a category to open its import/export workspace and history.
        </Typography>
      </div>

      <List>
        {categories.map((category) => (
          <ExportImportItem
            key={category.key}
            label={category.label}
            title={category.description}
            Icon={category.Icon}
            onClick={() => history.push(`/data-import-export/${category.key}`)}
          />
        ))}
      </List>
    </div>
  );
};

export default DataImportExport;
